import { ArrowUpRightFromSquare } from "@gravity-ui/icons";
import { Button, Flex, Icon, Text } from "@gravity-ui/uikit";
import React from "react";
import { Link } from "react-router-dom";

export interface PromotionElementProps {
  id: number;
  title: string;
  description: React.ReactNode;
  link?: string;
  blank?: boolean;
  success?: boolean;
}

export const PromotionElement = ({
  id,
  title,
  description,
  link,
  blank,
  success,
}: PromotionElementProps) => {
  return (
    <Flex direction={"column"}>
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex gap={2}>
          <Flex
            alignItems={"center"}
            justifyContent={"center"}
            style={{
              outline: `1px solid var(--g-color-text-${success ? "positive" : "danger"})`,
              borderRadius: "100%",
              width: 18,
              height: 18,
            }}
          >
            <Text color={success ? "positive" : "danger"}>{id}</Text>
          </Flex>

          <Text color={success ? "positive" : "danger"}>{title}</Text>
        </Flex>
        {link && (
          <Link to={link} target={blank ? "blank" : ""}>
            <Button>
              <Icon data={ArrowUpRightFromSquare} />
            </Button>
          </Link>
        )}
      </Flex>
      <Flex style={{ padding: "0 26px", maxWidth: 400 }}>
        <Text variant="caption-2">{description}</Text>
      </Flex>
    </Flex>
  );
};
